import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { FinanceiroService } from '../financeiro.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { Usuario } from '../../../models/usuario';
import { AuthService } from '../../admin/auth.service';
import { Perfis, Perfil } from '../../../models/perfis';
import { StatusControleLancamento } from '../../../models/statusControleLancamento';

@Component({
  selector: 'emprego-na-pistagerenciar-prestacao-contas',
  templateUrl: './gerenciar-prestacao-contas.component.html',
  styleUrls: ['./gerenciar-prestacao-contas.component.css']
})
export class GerenciarPrestacaoContasComponent extends WebPage implements OnInit {
  prestacoes: any[];
  public anos: any[] = [];
  public meses: any[] = [];
  public unidades: any[];
  public usuario: Usuario;
  constructor(messageService: MessageService,
    private _financeiroService: FinanceiroService,
    private arquivoService: ArquivoService,
    private _unidadeService: UnidadeService,
    private authService: AuthService,
  ) {
    super(messageService);
    this.usuario = this.authService.informacoesUsuario();
  }

  ngOnInit() {
    this.verificaMensagem();
    this.listaUnidades();
    if (this.usuario.Perfil.toUpperCase() === Perfis.GestorDex.toUpperCase() ||
      this.usuario.Perfil.toUpperCase() === Perfis.AdministrativoDex.toUpperCase() ||
      this.usuario.Perfil.toUpperCase() === Perfis.AdministradorSistema.toUpperCase()) {
      this.geAllLancamentos();
    } else {
      if (this.usuario.IdUnidade !== null) {
        this.geAllLancamentosByUnidade(this.usuario.IdUnidade);
      }
    }
  }

  verificaPerfil() {
    switch (this.usuario.Perfil) {
      case Perfis.GestorDex:
        return true;
      // break;
      case Perfis.AdministrativoDex:
        return true;
      // break;
      case Perfis.AdministradorSistema:
        return true;
      // break;
      default:
        return false;
      // break;
    }
  }

  verificaMensagem() {
    const mensagem = localStorage.getItem('mensagem');
    if (mensagem != null && mensagem !== '') {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: mensagem });
      localStorage.removeItem('mensagem');
    }
  }

  geAllLancamentos() {
    this._financeiroService.getAllLancamentoDetalhado()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.prestacoes = data;
          this.anos = this.prestacoes.map(u => u.ano)
            .reduce(
              (un, u) => {
                return (un.indexOf(u) < 0) ? un.concat([u]) : un;
              },
              []
            );
          this.meses = this.prestacoes.map(u => u.mes)
            .reduce(
              (un, u) => {
                return (un.indexOf(u) < 0) ? un.concat([u]) : un;
              },
              []
            );
            this.meses = this.meses.sort((n1, n2) => n1 - n2);
          // console.log(this.anos);
          // console.log(this.meses);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  geAllLancamentosByUnidade(id) {
    this._financeiroService.getAllLancamentoDetalhadoByUnidade(id)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.prestacoes = data;
          console.log(data);
          this.anos = this.prestacoes.map(u => u.ano)
            .reduce(
              (un, u) => {
                return (un.indexOf(u) < 0) ? un.concat([u]) : un;
              },
              []
            );
          this.meses = this.prestacoes.map(u => u.mes)
            .reduce(
              (un, u) => {
                return (un.indexOf(u) < 0) ? un.concat([u]) : un;
              },
              []
            );
          // console.log(this.anos);
          // console.log(this.meses);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }
  downloadArquivo(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Documento_Enviado_Analise');
  }

  listaUnidades() {
    this._unidadeService.getUnidades()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.unidades = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }
  verificaStatusBtnAnalise(idStatus: string) {
    return idStatus.toLocaleUpperCase() === StatusControleLancamento.IdCadastrado.toLocaleUpperCase()
      || idStatus.toLocaleUpperCase() === StatusControleLancamento.IdDevolvidoAjustes.toLocaleUpperCase()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/gerenciar-prestacao-contas/gerenciar-prestacao-contas.component.ts